export default __webpack_public_path__ + "static/media/Asset-1.d5c67edb.png";